import { render, staticRenderFns } from "./action-table-column.vue?vue&type=template&id=5f954d07&scoped=true"
import script from "./action-table-column.vue?vue&type=script&lang=ts"
export * from "./action-table-column.vue?vue&type=script&lang=ts"
import style0 from "./action-table-column.vue?vue&type=style&index=0&id=5f954d07&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f954d07",
  null
  
)

export default component.exports